async function getInstrumentStatusTypes () {
    return this.api({url: '/cars/types/instrument-status'})
}

async function getInstrumentTypes () {
    return this.api({url: '/cars/types/instrument'})
}

async function getInstrumentLocationTypes () {
    return this.api({url: '/cars/types/instrument-location'})
}

async function getInstrumentFunctionTypes () {
    return this.api({url: '/cars/types/instrument-function'})
}

async function getInstrumentFeatureTypes () {
    return this.api({url: '/cars/types/instrument-feature'})
}

async function getAvailabilityTypes () {
    return this.api({
        url: `/cars/types/availability`
    })
}

async function getLidarFunctionTypes () {
    return this.api({url: '/cars/types/lidar-instrument-function'})
}

async function getLidarFeatureTypes () {
    return this.api({url: '/cars/types/lidar-instrument-feature'})
}

async function getLidarChannelTypes () {
    return this.api({
        url: `/cars/types/lidar-channel-type`
    })
}

export default {
    pluginName: 'instrument',
    methods: {
        getInstrumentStatusTypes, getInstrumentTypes,
        getInstrumentLocationTypes, getInstrumentFunctionTypes, getInstrumentFeatureTypes,
        getAvailabilityTypes,
        getLidarFunctionTypes, getLidarFeatureTypes, getLidarChannelTypes
    }
}